export default __webpack_public_path__ + "c5d2128.png";